import { useContext } from "react";
import { Button } from "react-bootstrap";
import { IoSaveOutline } from "react-icons/io5";
import { DashboardContext } from "../../../contexts/Dashboard/DashboardContext";

const SaveButton = () => {
  const { save } = useContext(DashboardContext);

  return (
    <Button
      type="button"
      onClick={() => save()}
      variant="info"
    >
      <div className="display-flex">
        <IoSaveOutline />
        <div className="mx-3">Salvar</div>
      </div>
    </Button>
  );
};

export default SaveButton;
